import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faList } from '@fortawesome/pro-regular-svg-icons/faList'

export const defaultTranslations = {
    pluginName: 'Menu Items Carousel',
    pluginDescription: 'Create a list of menu items as links in a carousel.',
}

export const defaultSettings = {
    defaultText: '<p>Enter text here.</p>',

    Controls: () => <>Controls for this plugin were not provided</>,
    Renderer: () => <>Renderer for this plugin was not provided</>,
    translations: defaultTranslations,
    IconComponent: <FontAwesomeIcon icon={faList} size="3x" />,
}
